import React from "react";
import "./Benefits.css";
import remember from "../assets/remember.jpeg";
import reference from "../assets/reference.jpeg";
import reflect from "../assets/reflect.jpeg";
import relive from "../assets/relive.jpeg";
import pen from "../assets/pen.jpeg";
import clarity from "../assets/clarity.jpeg";
import eye from "../assets/eye.jpeg";
import heart from "../assets/heart.jpeg";
import thermo from "../assets/thermo.jpeg";
import mood from "../assets/mood.jpeg";
import bulb from "../assets/bulb.jpeg";
import plant from "../assets/plant.jpeg";

const Benefits = () => {
  return (
    <div>
      <div className="container">
        <div className="section-main">
          <h1 id="main-heading">Benefits of Keeping a Journal</h1>
          <br />
          <p>
            Journals primarily provide a private place to record life, for
            personal use and for posterity.
          </p>
          <br />
          <p>
            As well as the benefits of being able remember and reflect upon
            memories from the past, regular writing can also have profound
            benefits for our mental health, memory and creativity.
          </p>
        </div>

        <div className="section-2">
          <h2 className="sub-heading">Memory and Recollection</h2>
          <div className="row">
            <div className="col-md-6">
              <div className="section-1">
                <img className="pic" src={remember} alt="" />
                <h3 className="styleheading">Remember</h3>
                <p>
                  Recall past experiences in greater detail and with a greater
                  degree of accuracy.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="section-1">
                <img className="pic" src={reference} alt="" />
                <h3 className="styleheading">Reference</h3>
                <p>
                  Reference aspects of your daily life, such as the places
                  you've visited and recall ideas.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="section-1">
                <img className="pic" src={reflect} alt="" />
                <h3 className="styleheading">Reflect</h3>
                <p>
                  Look back on a situation or experience to gain insights and
                  better understand it.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="section-1">
                <img className="pic" src={relive} alt="" />
                <h3 className="styleheading">Relive</h3>
                <p>
                  Relive and remember a special moment from your past, such as a
                  wedding or birth.
                </p>
              </div>
            </div>
          </div>
        </div>
        <hr />

        <div className="section-2">
          <div className="sub-heading">Health and Well-Being</div>
          <div className="row">
            <div className="col-md-4">
              <div className="section-1">
                <img className="pic" src={pen} alt="" />
                <h3 className="styleheading">Catharsis</h3>
                <p>
                  Private writing provides the opportunity to release any
                  difficult thoughts or emotions.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="section-1">
                <img className="pic" src={clarity} alt="" />
                <h3 className="styleheading">Clarity</h3>
                <p>
                  Writing can help clear your mind of logical and creative
                  problems to help you focus better.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="section-1">
                <img className="pic" src={eye} alt="" />
                <h3 className="styleheading">Awareness</h3>
                <p>
                  Writing down thoughts helps you become more mindful of what
                  you're thinking or feeling.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="section-1">
                <img className="pic" src={heart} alt="" />
                <h3 className="styleheading">Appreciation</h3>
                <p>
                  Recording things you are grateful for can help you appreciate
                  the little thing you may often overlook.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="section-1">
                <img className="pic" src={thermo} alt="" />
                <h3 className="styleheading">Symptoms</h3>
                <p>
                  Keeping a record of any symptoms you experience can be useful
                  for reporting detailed notes to doctors.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="section-1">
                <img className="pic" src={mood} alt="" />
                <h3 className="styleheading">Mood</h3>
                <p>
                  Tracking your mood throughout the day helps identify and
                  resolve triggers of a specific mood.
                </p>
              </div>
            </div>
          </div>
        </div>
        <hr />

        <div className="section-2">
          <div className="sub-heading">Productivity and Development</div>
          <div className="row">
            <div className="col-md-6">
              <div className="section-1">
                <img className="pic" src={bulb} alt="" />
                <h3 className="styleheading">Inspiration</h3>
                <p>
                  Collecting inspiration, thoughts and ideas in one central
                  place can help ignite new ideas.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="section-1">
                <img className="pic" src={plant} alt="" />
                <h3 className="styleheading">Development</h3>
                <p>
                  Writing out your ideas and goals can help provide clarity and
                  focus to assist in more rapid development.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
